import React from "react";
import { Box, CardContent, Typography } from "@mui/material";
import { StyledCard } from "../styled";

const UploadSummaryCard = ({ totalRecords, conflictsResolved, excludedCount }) => (
  <StyledCard sx={{ mb: 3 }}>
    <CardContent>
      <Typography variant="h6" gutterBottom>
        Upload Summary
      </Typography>
      <Box display="flex" gap={4} flexWrap="wrap">
        <SummaryItem label="Total OSM Records" value={totalRecords} valueColor="primary" />
        <SummaryItem label="Conflicts Resolved" value={conflictsResolved} valueColor="warning.main" />
        <SummaryItem label="Excluded" value={excludedCount} valueColor="error.main" />
        <SummaryItem
          label="Ready to Upload"
          value={totalRecords - excludedCount}
          valueColor="success.main"
        />
      </Box>
    </CardContent>
  </StyledCard>
);

const SummaryItem = ({ label, value, valueColor }) => (
  <Box>
    <Typography variant="body2" color="textSecondary">
      {label}
    </Typography>
    <Typography variant="h4" sx={{ color: valueColor }}>
      {value}
    </Typography>
  </Box>
);

export default UploadSummaryCard;
